// ============================================================
// Thermal print helper — browser print window (kasir SPK & POS)
// ============================================================

function centerText(text, width) {
  const pad = Math.max(0, Math.floor((width - text.length) / 2));
  return ' '.repeat(pad) + text;
}

function padEnd(str, len) {
  return (str || '').toString().padEnd(Math.max(0, len));
}

export function printThermal(receipt) {
  if (receipt?.print_view_url) {
    window.open(receipt.print_view_url, 'PRINT_SPK', 'width=420,height=760');
    return;
  }

  const lines = receipt?.lines || [];
  const w     = receipt?.print_width || 32;
  const sep   = '-'.repeat(w);
  let text    = '';

  lines.forEach((line) => {
    switch (line.type) {
      case 'header':
      case 'subheader':
      case 'center':
      case 'footer':
        text += centerText(line.text, w) + '\n';
        break;
      case 'divider':
        text += sep + '\n';
        break;
      case 'info': {
        const val = line.value ?? '';
        text += padEnd(line.label, w - val.toString().length) + val + '\n';
        break;
      }
      case 'item': {
        const itemLine = line.name + ' x' + line.qty;
        const subtotal = Number(line.subtotal || 0);
        if (subtotal > 0) {
          const subtotalStr = 'Rp ' + subtotal.toLocaleString('id-ID');
          text += padEnd(itemLine, w - subtotalStr.length) + subtotalStr + '\n';
        } else {
          text += itemLine + '\n';
        }
        if (line.ukuran) {
          text += padEnd('  ' + line.ukuran, w) + '\n';
        }
        break;
      }
      case 'note':
        text += (line.text || '') + '\n';
        break;
      case 'subtotal':
      case 'total':
      case 'paid':
      case 'change':
      case 'discount': {
        const rightVal = typeof line.value === 'number'
          ? 'Rp ' + Number(line.value).toLocaleString('id-ID')
          : (line.value || '');
        text += padEnd(line.label, w - rightVal.length) + rightVal + '\n';
        break;
      }
      default:
        if (line.text) text += line.text + '\n';
    }
  });

  const win = window.open('', 'PRINT', 'width=380,height=600');
  if (!win) return;

  win.document.write(`<!DOCTYPE html><html><head><style>
    body { font-family: monospace; font-size: 12px; width: ${w * 7}px; padding: 8px; }
    pre  { white-space: pre; }
  </style></head><body><pre>${text}</pre>
  <script>window.onload=()=>{window.print();window.close();}<\/script></body></html>`);
  win.document.close();
}

window.printThermal = printThermal;
